const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000').replace(/\/+$/, '');
export const MEDIA_BASE_URL = import.meta.env.VITE_MEDIA_BASE_URL || API_BASE_URL;

export const formatDate = (value) => {
  if (!value) return '';
  const parsed = new Date(value);
  return parsed.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

export const formatTime = (value) => {
  if (!value) return '';
  const parsed = new Date(`1970-01-01T${value}`);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};

export const combineEventDateTime = (dateValue, timeValue, fallbackValue = '') => {
  if (dateValue && timeValue && /^\d{4}-\d{2}-\d{2}$/.test(String(dateValue))) {
    return `${dateValue}T${timeValue}`;
  }
  return dateValue || fallbackValue;
};

export const formatCurrency = (value) => {
  const amount = Number(value || 0);
  return `QAR ${amount.toFixed(2)}`;
};

export const formatEventDateTime = (value, options = {}) => {
  if (!value) return '-';

  const hasDisplayDate = typeof options.displayDate === 'boolean';
  const hasDisplayTime = typeof options.displayTime === 'boolean';
  const showDate = hasDisplayDate ? options.displayDate : true;
  const showTime = hasDisplayTime ? options.displayTime : true;

  const normalized = String(value).replace(' at ', ' ');
  const parsed = new Date(normalized);

  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  if (!showDate && !showTime) return '-';

  if (showDate && showTime) {
    return parsed.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  }

  if (showDate) {
    return parsed.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  return parsed.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const withBaseUrl = (url) => {
  if (!url) return '';
  if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:') || url.startsWith('blob:')) {
    return url;
  }
  return `${MEDIA_BASE_URL}${url.startsWith('/') ? '' : '/'}${url}`;
};

export const isTicketAvailable = (ticket) => {
  if (ticket?.status && ticket.status !== 'active') return false;
  if (ticket?.session_inventory_configured) {
    return Number(ticket.session_seats_left ?? 0) > 0;
  }
  if (ticket?.quantity === null || ticket?.quantity === undefined) return true;
  return Number(ticket.quantity) > 0;
};

export const getSessionTickets = (session, fallbackTickets = []) => session?.ticket_types?.length ? session.ticket_types : fallbackTickets;

export const getSessionSeatsLeft = (session, fallbackTickets = []) => {
  const tickets = getSessionTickets(session, fallbackTickets);
  const ticketSeats = tickets
    .map((ticket) => ticket.session_inventory_configured ? Number(ticket.session_seats_left ?? 0) : Number(ticket.quantity ?? 0))
    .filter((value) => Number.isFinite(value));

  if (ticketSeats.length === 0) return null;
  return ticketSeats.reduce((total, value) => total + value, 0);
};

export const isSessionAvailable = (session, fallbackTickets = []) => getSessionTickets(session, fallbackTickets).some(isTicketAvailable);

export const getGoogleMapsUrl = (venue, fallbackLocation) => {
  const query = venue?.address || venue?.name || fallbackLocation;
  if (!query) return '';
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
};
